import React from "react";

import API from "../../base/API";

import moment from "moment";

import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

import { translate } from "../../base/Translation";

const DAY_FORMAT = 'DD.MM.YYYY';
const DAY_TIME_FORMAT = 'DD.MM.YYYY    HH:mm';
moment.locale("sk");

export default class InlineForm extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            update_field: "/test/update/field/:test"
        });

        this.state = {
            value: this.props.value === null ? "" : this.props.value,
            oldValue: "",
            isEditing: false
        }
    }

    onSave() {
        this.api.request({
            cache: false,
            route: "update_field",
            data: { field: this.props.field, value: this.state.value },
            params: { test: this.props.test },
            success: (response) => {
                if (typeof this.props.onSuccess !== "undefined") {
                    this.props.onSuccess(this.state.value, this.state.oldValue);
                }
                this.setState({ isEditing: false });
                window.dispatchEvent(new Event("reloadLog"));
            }
        });
    }

    onChange(evt) {
        this.setState({ value: evt.target.value });
    }

    onCancel() {
        this.setState({ isEditing: false, value: this.state.oldValue })
    }

    onEdit() {
        if (this.props.readonly === true) {
            return;
        }
        this.setState({ isEditing: true, oldValue: this.state.value });
    }

    onDateChange(event, datepicker) {
        let date = datepicker.startDate; // moment object
        this.setState({ value: date.format(DAY_TIME_FORMAT) });
    }

    renderSelect() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="input-group input-group-sm">

                        <select value={this.state.value}
                            onChange={this.onChange.bind(this)}
                            className="form-control">
                            {this.props.options.map((option, index) => {
                                return <option value={option.value} key={index}>{option.text}</option>;
                            })}
                        </select>

                        <span className="input-group-btn">
                            <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                                <i className="fa fa-save" />
                            </button>
                            <button className="btn btn-primary" onClick={this.onCancel.bind(this)}>
                                <i className="fa fa-close" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    renderInput() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="input-group input-group-sm">
                        <input type="text" value={this.state.value} onChange={this.onChange.bind(this)} className="form-control" />
                        <span className="input-group-btn">
                            <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                                <i className="fa fa-save" />
                            </button>
                            <button className="btn btn-primary" onClick={this.onCancel.bind(this)}>
                                <i className="fa fa-close" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    renderDateTime() {
        let locale = {
            format: DAY_FORMAT,
            separator: ' - ',
            applyLabel: translate("Vybrať"),
            cancelLabel: translate("Zrušiť"),
            weekLabel: 'W',
            customRangeLabel: translate("Vlastný rozsah"),
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek(),
        };

        let date = moment(new Date(), DAY_TIME_FORMAT);

        if (this.props.value) {
            date = moment(this.props.value, DAY_TIME_FORMAT);
        }

        if (this.state.value) {
            date = moment(this.state.value, DAY_TIME_FORMAT);
        }

        return (
            <DatetimeRangePicker startDate={date} locale={locale} timePickerIncrement={5} timePicker timePicker24Hour showDropdowns singleDatePicker
                onApply={this.onDateChange.bind(this)} >
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <div className="input-group input-group-sm">
                            <input type="text" className="form-control" value={date.format(DAY_TIME_FORMAT)} readOnly />
                            <span className="input-group-btn">
                                <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                                    <i className="fa fa-save" />
                                </button>
                                <button className="btn btn-primary" onClick={this.onCancel.bind(this)}>
                                    <i className="fa fa-close" />
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </DatetimeRangePicker>
        )
    }

    render() {

        if (!this.state.isEditing) {

            let value = this.state.value;

            if (this.props.type === "select") {
                const option = this.props.options.find((option) => option.value === this.state.value);
                value = typeof option !== "undefined" ? option.text : "";
            }

            value = value ? value : "-----";

            return (
                <span onClick={this.onEdit.bind(this)}>
                    {this.props.readonly !== true ? <span><i className="fa fa-edit" />  </span> : ""}
                    {value} {typeof this.props.suffix !== "undefined" ? this.props.suffix : ""}
                </span>
            )
        }

        switch (this.props.type) {
            case "select":
                return this.renderSelect();
            case "datetime":
                return this.renderDateTime();
            default:
                return this.renderInput();
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/InlineForm.jsx